import React, {Component} from "react"
import Input from "../../../common/components/forms/input"
import Radio from "../../../common/components/forms/radio"
import {Dialog} from "../../../common/components/dialog"
import {validate} from "../../../common/components/forms/validation"
import Button from "../../../common/components/button"
import {connect} from "react-redux";
import {createDiscRequest} from "../../actions/disc-actions";
import {DISC_MEDIA_TYPE} from "../../actions/disc-constants"
import "../../style/disc-dialog.scss"

class DiscProjectEditDialog extends Component {

    constructor(props) {
        super(props);
        this.state = this.getResetState()

        this.save = this.save.bind(this)
        this.open = this.open.bind(this)
        this.getResetState = this.getResetState.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.validateInput = this.validateInput.bind(this)
        this.onFocus = this.onFocus.bind(this)
        this.handleInputKeyPress = this.handleInputKeyPress.bind(this)
    }
    getResetState(){
        let baseData = {
            id: null,
            discPackageType: "",
            caseTitle: "",
            caseSubtitle: "",
            caseSpineTitle: ""
        }
        if(this.props != null && this.props.data != null){
            baseData = {...this.props.data}
            if(baseData.discPackageType === "PhotoCdPackage" || baseData.discPackageType === "dvd_photo_data"){
                baseData.discPackageType = "dvd_photo_data"
            }else if(baseData.mediaType === DISC_MEDIA_TYPE.BLURAY_MEDIA_TYPE){
                baseData.discPackageType = "bluray_video"
            }else{
                if(this.props.discPackageType == null) {
                    baseData.discPackageType = "dvd_video"
                }else{
                    if(this.props.discPackageType === "PhotoCdPackage") {
                        baseData.discPackageType = "dvd_photo_data";
                    }else{
                        baseData.discPackageType = "dvd_video"
                    }
                }
            }
        }else{
            if(this.props.discPackageType == null) {
                baseData.discPackageType = "dvd_video"
            }else{
                if(this.props.discPackageType === "PhotoCdPackage") {
                    baseData.discPackageType = "dvd_photo_data";
                }else{
                    baseData.discPackageType = "dvd_video"
                }
            }
        }
        return {
            isSaving: false,
            data: baseData,
            validation: {
                isValid: true,
                fields: {
                    caseTitle: { required: true,fontMetrics: {max:19}},
                    caseSubtitle: {fontMetrics: {max:19}},
                    caseSpineTitle: { required: true, fontMetrics:{max:19}},
                    discPackageType: { required: true }
                }

            },
            instructionImg: require("../../images/disc-project-edit-title.png")
        }
    }
    handleBlur(fieldData){
        let validation = {...this.state.validation}
        if(typeof(validation.fields[fieldData.field]) !== "undefined" && validation.fields[fieldData.field] !== null){
            delete validation.fields[fieldData.field].validationResult;
            this.setState({validation: validation})
        }
        let data = {...this.state.data}
        let prevValue = this.state.data[fieldData.field]
        data[fieldData.field] = fieldData.value;
        if(fieldData.field === "caseTitle"){
            if(prevValue === data.caseSpineTitle){
                data.caseSpineTitle = fieldData.value;
            }
        }
        this.setState({...this.state, data: data})
    }
    open(){
        this.setState(this.getResetState());
        this.discEditDialog.open();
    }
    componentWillReceiveProps(nextProps){
        if (nextProps.discGlobalState.saveSuccessful === true && this.state.isSaving) {
            this.discEditDialog.close()
        }
        if (nextProps.isOpen && !this.props.isOpen) {
            this.open()
        } else if (!nextProps.isOpen) {
            this.discEditDialog.close()
        }
        if (typeof (nextProps.data) !== "undefined" && nextProps.data !== null && this.state.data == null) {
            let disc = Object.assign(nextProps.data)
            if (disc.discPackageType === "PhotoCdPackage" || disc.discPackageType === "dvd_photo_data") {
                disc.discPackageType = "dvd_photo_data"
            } else if (this.state.data.mediaType === DISC_MEDIA_TYPE.BLURAY_MEDIA_TYPE) {
                disc.discPackageType = "bluray_video"
            } else {
                disc.discPackageType = "dvd_video"
            }
            this.setState({data: disc});
        }
    }
    save(){
        if(this.validateInput()){
            this.setState({isSaving: true})
            this.props.createDiscRequest(this.state.data.caseTitle, this.state.data.caseSubtitle, this.state.data.caseSpineTitle, this.state.data.discPackageType,this.state.data.id)
        }
    }
    validateInput(){
        let validation = {...this.state.validation};
        validation.isValid = true;

        for(var field in validation.fields){
            let validationResult = {isValid:true,rules:[]};

            let validationRuleResults = validate(validation.fields[field],this.state.data[field]);
            for(let ruleIndex in validationRuleResults){
                validationResult.isValid = validationResult.isValid && validationRuleResults[ruleIndex].isValid
            }
            validation.isValid = validation.isValid && validationResult.isValid
            validationResult.rules = validationRuleResults;
            validation.fields[field].validationResult = validationResult
        }
        if(!validation.isValid){
            validation.message = "Please fix the following issues first"
        }else{
            validation.message = "";
        }
        this.setState({validation: validation})
        return validation.isValid;
    }
    onFocus(event){
        if(event.target.name === "caseTitle"){
            this.setState({instructionImg: require("../../images/disc-project-edit-title.png")})
        }else if(event.target.name === "caseSubtitle"){
            this.setState({instructionImg: require("../../images/disc-project-edit-subtitle.png")})
        }else if(event.target.name === "caseSpineTitle"){
            this.setState({instructionImg: require("../../images/disc-project-edit-spine.png")})
        }
        else {
            this.setState({instructionImg: require("../../images/disc-project-edit.jpg")})
        }

    }
    handleInputKeyPress(evt){
        if(evt.key === "Enter"){
            evt.preventDefault();
            document.activeElement.blur();
            setTimeout(this.save,100)
        }
    }

    render() {

        const dialogTitle = this.state.data.id > 0 ? "Edit Disc": "Create New Disc";
        return (
            <Dialog className="disc-project-edit-dialog"
                    ref={discEditDialog => (this.discEditDialog = discEditDialog)}
                    title={dialogTitle}
                    canCancel={false}
                    onClose={this.props.onClose}
                    isOpen={this.props.isOpen}>
                <DiscProjectEditContent validation={this.state.validation}
                                        data={this.state.data}
                                        saveDisk={this.save}
                                        close={this.props.onClose}
                                        onBlur={this.handleBlur}
                                        isSaving={this.state.isSaving}
                                        instructionImg={this.state.instructionImg}
                                        inputFocusChanged={this.onFocus}
                                        discPackageType={this.props.discPackageType}
                                        handleInputKeyPress={this.handleInputKeyPress}/>
            </Dialog>
        )
    }
}
const DiscProjectEditContent = (props) => {
    const {data, validation, saveDisk, close, onBlur, isSaving, instructionImg,inputFocusChanged,discPackageType,handleInputKeyPress} = props;
    const allDiscOptions = []
    let hasDVDOption = false;
    if(typeof(discPackageType) === "undefined" || discPackageType === null || discPackageType === "any" || discPackageType === "DvdPackage"){
        hasDVDOption = true;
        allDiscOptions.push({key:"dvd_video",discPackageType:"DvdPackage",default:true,label:<span><img src={require("../../images/disc_dvd_video.png")} alt="DVD Video"/>DVD disc (Video)</span>});
        allDiscOptions.push({key:"bluray_video",discPackageType:"DvdPackage",default:false,label:<span><img src={require("../../images/disc_blu_ray.png")} alt="Blu-ray Video"/>Blu-ray disc (Video)</span>})
    }
    if(typeof(discPackageType) === "undefined" ||  discPackageType === null || discPackageType === "any" || discPackageType === "PhotoCdPackage") {
        allDiscOptions.push({key: "dvd_photo_data",discPackageType:"PhotoCdPackage",default:!hasDVDOption,
            label: <span><img src={require("../../images/disc_dvd_photo.png")}
                              alt="Photograph Disc"/>DVD disc (Photo)</span>
        })
    }
    const discOptions = allDiscOptions.filter(item => ((typeof(data.id)==="undefined" || data.id===null) || (item.key === data.discPackageType)))
    return (
        <div className="disc-project-edit-dialog-content">
            <div className="disc-project-edit-content">
                <div className="disc-project-edit-form">
                    <form onSubmit={(evt)=>{evt.preventDefault();document.activeElement.blur();setTimeout(saveDisk,100)}}>
                        <Radio options={discOptions}
                               value={data.discPackageType}
                               name="discPackageType"
                               className="disc-project-disc-type"
                               onChange={onBlur}
                               groupTitle="Select a disc type:"
                               validation={validation.fields.discPackageType}
                               readOnly={data.id !== null && data.id > 0}
                        />
                        <p style={{fontSize: "1.0em", fontStyle: "italic"}}>*Titles limited to apx 20 characters</p>
                        <Input value={data.caseTitle}
                               className="disc-project-disc-title"
                               name="caseTitle"
                               label="Title"
                               validation={validation.fields.caseTitle}
                               onBlur={onBlur}
                               onFocus={inputFocusChanged}
                               onKeyPress={handleInputKeyPress}/>
                        <Input value={data.caseSubtitle}
                               className="disc-project-disc-subtitle"
                               name="caseSubtitle"
                               label="Subtitle"
                               validation={validation.fields.caseSubtitle}
                               onBlur={onBlur}
                               onFocus={inputFocusChanged}
                               onKeyPress={handleInputKeyPress}/>
                        <Input value={data.caseSpineTitle}
                               className="disc-project-disc-type"
                               name="caseSpineTitle"
                               label="Spine"
                               validation={validation.fields.caseSpineTitle}
                               onBlur={onBlur}
                               onFocus={inputFocusChanged}
                               onKeyPress={handleInputKeyPress}/>
                        <input type="submit" style={{display:"none"}}/>
                    </form>
                </div>
                <div className="disc-project-edit-disc-label-diagram">
                    <img src={instructionImg} alt="Disc Label Diagram" className="overlay-image"/>
                    <img src={require("../../images/disc-project-edit.jpg")} className="base-image" alt="Disc Sample"/>
                </div>
            </div>
            <div className="btn-dialog-container">
                <Button buttonStyle="primary" className="btn-dialog" buttonLabel={isSaving?"Saving ...":"Save"} disabled={isSaving} onClick={saveDisk} />
                <Button buttonStyle="secondary" className="btn-dialog" buttonLabel="Cancel" onClick={close} disabled={isSaving}/>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        discGlobalState: state.disc
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createDiscRequest: (title, subtitle, spineTitle, discType, id) => {
            dispatch(createDiscRequest(dispatch, title, subtitle, spineTitle, discType, id));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscProjectEditDialog);




// WEBPACK FOOTER //
// ./src/disc/components/dialog/disc-project-edit-dialog.jsx